import base from './base.jsx';
import { FadeLoader } from 'react-spinners'

class Table extends base.FilteredComponent {
  constructor(props) {
    super(props);

    this.requestIndex = 0;
    this.pageNumber = 0;
  }

  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      data: [],
      canLoadMore: false,
      busyLoading: false,
      pageSize: this.props.pageSize || 10,
      useOffset: this.props.useOffset || false,
      sortDirections: {},
      isVisible: this.props.isVisible !== undefined ? this.props.isVisible : true,
      useSubItems: this.props.useSubItems || false,
      responsiveExpandedRows: {},
      hasResponsive: false,
      hasNoData: false,
      waitForFilterLoad: true
    });
  }

  componentWillMount() {
    super.componentWillMount();
    radio("reloadTable").subscribe(this.handleFiltersChanged.bind(this));
    this.getTableSortParamsFromQuery();
    if (!this.state.waitForFilterLoad) {
      this.loadData(true, {}, '', null);
    }
  }

  getTableSortParamsFromQuery() {
    var queryParams = URI(document.URL).query(true);
    if (queryParams && queryParams.sort) {
      this.setState(currentState => {
        currentState.sortedColumn = queryParams.sort;
        currentState.sortDirections[queryParams.sort] = queryParams.sortDirection === 'asc'
  
        return currentState;
      });
    }
  }

  handleFiltersChanged(filters, searchString) {
    if (this.state.isVisible) {
      this.loadData(true, filters, searchString, null);
    } else {
      this.setState({
        busyLoading: true,
        busyReloading: true
      })
      setTimeout(function() {this.loadData(true, filters, searchString, null);}.bind(this),1000);
    }
  }

  setSortedColumn(column) {
    this.setState(currentState => {
      //If we are already sorting on this column reverse direction
      if (currentState.sortedColumn === column) {
        currentState.sortDirections[column] = !currentState.sortDirections[column];
      }
      currentState.sortedColumn = column;

      //update the URL
      var sortOptions = this.getSortOptionsFromState(currentState);
      if (sortOptions) {
        var uri = URI(window.location);
        var parameters = {
          "sort": sortOptions.column,
          "sortDirection": sortOptions.direction
        }
        uri.setSearch(parameters);
        if (history.replaceState) {
          history.replaceState(parameters, document.title, uri.toString());
        }

        this.loadData(true, null, null, sortOptions);
      }

      return currentState;
    });
  }

  getSortOptionsFromState(state) {
    if (state && state.sortedColumn) {
      return {
        column: state.sortedColumn,
        direction: state.sortDirections[state.sortedColumn] ? "asc" : "desc"
      }
    } else {
      return null;
    }
  }

  /* These are functions you should probably override */

  /* The header of the table you can define column sizes here (using classes)
     Rember to use <th> and not <td> */
  getHeader() {
    return
  }

  /* Each individual row of the table, use this to render the data */
  getRow(rowData, index) {
    return
  }

  /* Row used to group items that are grouped together */
  getGroupHeader(group) {
    return
  }

  /* Footer displayed at the end of the table */
  getFooter() {
    return
  }

  /* End of functions you probably want to override */

  getRows() {
    var index = -1;
    return <tbody>
      {
        this.state.data.map(row => {
          index += 1;
          if (row.subItems || this.state.useSubItems) {
            var group = [];
            var groupIndex = -1;
            group.push(this.getGroupHeader(row, index));
            if (row.subItems) {
              { row.subItems.map(subItem => {
                groupIndex += 1;
                group.push(this.getRow(subItem, groupIndex, index));
              })};
            }
            return group;
          } else {
            return this.getRow(row, index)
          }
        })
      }
    </tbody>
  }

  getIsLastSubItem(groupIndex, index) {
    if (this.state.data && this.state.data[index].subItems.length == groupIndex + 1) {
      return true
    } else {
      return false
    }
  }

  updateData(newObject) {
    var index;
    //Loop through all items
    for (index = 0; index < this.state.data.length; ++index) {
      var currentItem = this.state.data[index];
      //If there are sub items loop through them
      if (currentItem.subItems) {
        var subIndex;
        for (subIndex = 0; subIndex < currentItem.subItems.length; ++subIndex) {
          var currentSubItem = currentItem.subItems[subIndex];
          //If the sub item has the same uuid as our new object, replace it
          if (currentSubItem.uuid == newObject.uuid) {
            this.setState(currentState => {
              currentState.data[index].subItems[subIndex] = newObject;

              return currentState;
            });
            //And stop
            return;
          }
        }
      } else if (currentItem.uuid == newObject.uuid) {
        //If there are no sub items, and the current item has the same uuid,
        //replace it
        this.setState(currentState => {
          currentState.data[index] = newObject;

          return currentState;
        });
        //And stop
        return;
      }
    }
  }

  countItemsLoaded(newData) {
    var count = 0;
    if (newData && newData.length > 0) {
      if (this.state.useSubItems
        || newData[0].subItems == undefined || newData[0].subItems == null) {
        count = newData.length;
      } else {
        newData.map(data => {
          count += data.subItems.length;
        });
      }
    }

    return count;
  }

  concatData(newData) {
    this.setState(currentState => {
      var count = this.countItemsLoaded(newData);
      if (newData && newData.length > 0) {
        if (currentState.data && currentState.data[0].subItems) {
          var lastObject = currentState.data[currentState.data.length - 1];
          if (lastObject.title == newData[0].title) {
            lastObject.subItems = lastObject.subItems.concat(newData[0].subItems);
            newData.shift();
          }
        }

        currentState.data = currentState.data.concat(newData);
      }

      if (count < this.state.pageSize) {
        currentState.canLoadMore = false;
      } else {
        currentState.canLoadMore = true;
      }

      return currentState;
    });
  }

  loadNext() {
    this.pageNumber++;
    this.loadData(false, null, null, null);
  }

  getOldestUUID() {
    var dataLength = this.state.data.length;
    if (dataLength > 0) {
      var lastObject = this.state.data[dataLength-1];
      if (lastObject.subItems) {
        return lastObject.subItems[lastObject.subItems.length-1].uuid
      } else {
        return lastObject.uuid
      }
    }

    return ""
  }

  loadData(busyReloading, filters, searchString, sortOptions) {
    var loading = null;
    this.setState({
      busyLoading: true,
      busyReloading: busyReloading,
      error: null
    });

    //TODO: handle there being a parameter already on API
    var url = this.props.api +
      "?pageSize=" +
      this.state.pageSize +
      "&filters=" +
      this.getFilterParameterString(filters, true);

    var sortOptions = sortOptions ? sortOptions : this.getSortOptionsFromState(this.state);

    if (sortOptions) {
      url += "&sort=" + sortOptions.column + "&sortDirection=" + sortOptions.direction;
    }

    url = url + this.getSearchParameterstring(searchString);

    if (!busyReloading) {
      if (this.state.useOffset) {
        url = url + "&offset=" + this.state.pageSize * this.pageNumber;
      } else {
        url = url + "&oldestUUID=" + this.getOldestUUID();
      }
    } else {
      this.pageNumber = 0;
    }

    this.requestIndex += 1;
    var index = this.requestIndex;

    $.ajax({
      url: url,
      dataType: "json",
      type: "GET"
    }).done((data, textStatus) => {
      this.setState({
        busyLoading: false,
        busyReloading: false
      });

      if (index == this.requestIndex) {
        if (data.status > 299) {
          this.showError(data.message);
        } else {
          this.dataLoaded(data);

          var loadedData = [];

          if (this.props.listKey) {
            loadedData = data["data"][this.props.listKey];
          } else {
            for (var key in data["data"]) {
              var object = data["data"][key];
              if (object instanceof Array) {
                loadedData = object;
              }
            }
          }

          if (this.props.storeAdditionalDataPath) {
            this.setState({
              additionalData: data["data"][this.props.storeAdditionalDataPath]
            });

            if (this.props.saveAdditionalData) {
              this.props.saveAdditionalData(data["data"][this.props.storeAdditionalDataPath]);
            }
          }

          if (busyReloading) {
            this.setState({
              data: loadedData,
              canLoadMore: this.countItemsLoaded(loadedData) == this.state.pageSize,
              hasNoData: loadedData.length == 0
            });
          } else {
            this.concatData(loadedData);
          }
        }
      }
    }).fail((jqXHR, textStatus, errorThrown) => {
      if (index == this.requestIndex) {
        this.setState({
          busyLoading: false,
          busyReloading: false
        })
        this.showError(errorThrown);
      }
    })
  }

  dataLoaded(data) {
    //Place any custom things you want to do with the data here
  }

  showError(errorMessage) {
    console.log("Error fetching: " + this.props.api)
    console.log(errorMessage)
    this.setState({
      error: errorMessage
    })
  }

  getStartDate() {
    if (this.state.filters &&
      this.state.filters.created &&
      this.state.filters.created.length > 1) {
      return moment(this.state.filters.created[0]).format("YYYY/MM/DD");
    }
    return "";
  }

  getEndDate() {
    if (this.state.filters &&
      this.state.filters.created &&
      this.state.filters.created.length > 1) {
      return moment(this.state.filters.created[1]).format("YYYY/MM/DD");
    }
    return "";
  }

  getEmptyStringSuffix() {
    if (this.state.data && this.state.data.length > 0) {
      return "No more results from ";
    } else {
      return "No results found from ";
    }
  }

  getEmptyString() {
    return this.getEmptyStringSuffix() +
      this.getStartDate() + " to " + this.getEndDate() +
      ", you may need to adjust your filters";
  }

  getPagingController() {
    if (this.state.canLoadMore) {
      if (this.state.busyLoading) {
        return <div className="load-more" onClick={this.loadNext.bind(this)}>
          <FadeLoader color={'silver'} height={15} width={5} radius={2} margin={2}/>
        </div>
      } else {
        return <div className="load-more" onClick={this.loadNext.bind(this)}>
          <i className="icon-streamline-sync"></i>
          Load more
        </div>
      }
    } else {
      if (this.state.hideNoResults) {
        return
      }

      return <div className="load-more empty">
        { this.getEmptyString() }
      </div>
    }
  }

  getTableClass() {
    return "new-table"
  }

  retry() {
    this.loadData(false, null, null, null)
  }

  getErrorContent() {
    if (this.state.error) {
      return <div className="alert alert-danger" onClick={this.retry.bind(this)}>
          There was an error fetching results, click to retry
        </div>
    } else {
      return
    }
  }

  getBlockClass() {
    var blockClass = "list-block ";
    if (this.state.blockClass) {
      blockClass += this.state.blockClass;
    } else {
      blockClass += "new-table-block";
    }

    if (this.state.hasResponsive) {
      blockClass += " hide-table-responsive";
    }

    return blockClass;
  }

  getResponsiveLineItem(label, value, isNumber, className) {
    var lineClass = "line-item";
    if (className) {
      lineClass += " " + className;
    }

    if (value) {
      if (isNumber) {

        return <div className={lineClass}>
          { label }
          <waffle.misc.FormattedNumber number={value}/>
        </div>
      } else {
        return <div className={lineClass}>
          { label }
          <waffle.misc.Amount amount={value}/>
        </div>
      }
    }
  }

  expandResponsiveRow(rowIndex) {
    this.setState(currentState => {
      currentState.responsiveExpandedRows[rowIndex] = !currentState.responsiveExpandedRows[rowIndex]
    });
  }

  getResponsiveRow(row, rowIndex) {
    console.log(["Overload getResponsiveRow to render this row", row, rowIndex]);
  }

  getResponsiveContent() {
    if (this.state.hasResponsive) {
      var rowIndex = 0;
      return <div className="responsive-table">
        {
          this.state.data.map(row => {
            rowIndex += 1;
            return this.getResponsiveRow(row, rowIndex)
          })
        }
      </div>
    } else {
      return
    }
  }

  getEmptyContent() {
    if (this.state.hasNoData && this.props.emptyTable) {
      return this.props.emptyTable
    } else {
      return
    }
  }

  render() {
    var loadingClass = "loading-view";
    if (!this.state.busyReloading) {
      loadingClass += " gone";
    }

    return <div className={ this.getBlockClass() }>
      { this.getErrorContent() }
      <div className="table-content react-table-content" ref="tableContent">
        <table className={ this.getTableClass() }>
          <thead>{ this.getHeader() }</thead>
          { this.getRows() }
          { this.getFooter() }
        </table>
        { this.getPagingController() }
      </div>
      { this.getResponsiveContent() }
      { this.getEmptyContent() }
      <div className={ loadingClass }>
        <div className="spacer"/>
        <FadeLoader color={'silver'} height={15} width={5} radius={2} margin={2}/>
        <div className="spacer"/>
      </div>
    </div>
  }
}

class InlineTable extends Table {
  getHeader() {
    if (this.props.titles) {
      return <tr>
        { this.props.titles.map((title, titleIndex) => {
          return <th key={`title-${titleIndex}`}>{title}</th>
        })}
      </tr>
    }
  }

  getRow(row, rowIndex) {
    if (row instanceof Array) {
      return <tr key={`row-${rowIndex}`}>
        { row.map((column, columnIndex) => {
          return <td key={`column-${rowIndex}-${columnIndex}`}>{ column }</td>
        })}
      </tr>
    } else {
      return <tr><td>{ row }</td></tr>
    }
  }

  /* Each individual row of the table, use this to render the data */
  getRows() {
    return <tbody>
      { this.props.rows.map((row, rowIndex) => {
        return this.getRow(row, rowIndex)
      })}
    </tbody>
  }

  render() {
    return <div className="list-block inline-table">
      <div className="table-content">
        <table>
          <thead>{ this.getHeader() }</thead>
          { this.getRows() }
          { this.getFooter() }
        </table>
      </div>
    </div>
  }
}

class SortableTableHeader extends base.BaseComponent {
  getRowClass() {
    return this.props.className ? this.props.className + " sortable unselectable" : "sortable unselectable";
  }

  getArrowClass() {
    var arrowClass = "inactive";
    if (this.props.table.state.sortedColumn == this.props.column) {
      arrowClass = "active";
    }
    if (this.props.table.state.sortDirections[this.props.column]) {
      arrowClass += " icon-arrow-57";
    } else {
      arrowClass += " icon-arrow-58";
    }
    return arrowClass;
  }

  render() {
    return <th
      className={ this.getRowClass() }
      onClick={ this.props.table.setSortedColumn.bind(this.props.table, this.props.column) }
    >
      { this.props.children }
      <i className={ this.getArrowClass() }/>
    </th>
  }
}

class EmptyTableView extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      "title": this.props.title || "No data found!",
      "imageURL": this.props.imageURL || "https://gallery.mailchimp.com/a760990646081d6b10a4ef6c3/images/a4e9ea5b-b5a7-4aac-acb9-5cc230a4b5d0.png"
    })
  }

  render() {
    return <div className="empty-table">
      <div className="title">
        { this.state.title }
      </div>
      <img src={ this.state.imageURL }/>
      <div className="sub-title">
        { this.props.children }
      </div>
    </div>
  }
}

module.exports = {
  Table: Table,
  InlineTable: InlineTable,
  SortableTableHeader: SortableTableHeader,
  EmptyTableView: EmptyTableView
}
